// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__dr5Wb","title":"ModalHeader_title__FwHyu","closer":"ModalHeader_closer__4sub2","disabled":"ModalHeader_disabled__1jSfz"};